import { React } from "react";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { useDispatch } from "react-redux";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { openModal } from "../../../store/slices/modal/modalSlice";
import { editCredentials } from "../../../store/slices/costing/costingSlice";
const DeleteButtonAccount = ({ index, label }) => {
  const dispatch = useDispatch();

  const openModalToDelete = ()=>{
    dispatch(editCredentials(index))
    dispatch(openModal("DeleteButtonAccount"))
  }


  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Delete Account
    </Tooltip>
  );
  

  return (
    <div className="d-flex">
           <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltipDelete}
      >
       
          <Button  variant="danger" onClick={()=>{openModalToDelete()}}>
            {label ? (
              <span className="cco-danger-label">{label}</span>
            ) : (
              <div  id="dual-svg-container-44"> 
                <DeleteTwoToneIcon color="action"  sx={{ fontSize: 30,color:"white" }}/>
              </div>
            )}
          </Button>
         
        
      </OverlayTrigger>
    </div>
  );
};

export default DeleteButtonAccount;
